module.exports = __webpack_public_path__ + "img/组 384.9b5961d1.png";